<script>
    import Cargo from "./pages/cargo/Cargo.svelte"
    import Landing from "./pages/landing/Landing.svelte"
    import Updates from "./pages/updates/Updates.svelte"
    import Router from 'svelte-spa-router'
    import {onMount} from "svelte";
    import {getCurrentUser, onLogin, wasLoggedIn} from "./api/user";
    import OurHeader from "./components/OurHeader.svelte";
    import LinearProgress from "@smui/linear-progress";

    const routes = {
        '/': Landing,
        // '/board': Cargo,
        // '/updates': Updates,
    }

    let loggedIn = false;
    let loading = true;

    onMount(() => {
        if (!wasLoggedIn()) {
            loading = false;
        }

        onLogin(() => {
            loggedIn = getCurrentUser();
            // loggedIn = true
            loading = false;
        })
    })
</script>

<div style="display: flex; flex-flow: column; height: 100%;">
    <OurHeader/>

    <div style="height: calc(100% - 50px);">
        <!--{#if loading}-->
        <!--    <CircularProgress/>-->
        <!--{:else if loggedIn}-->
        <!--    <Router {routes}/>-->
        <!--{:else}-->
        <!--    <div style="width: 100%; margin-top: 20px; text-align: center">Please sign in</div>-->
        <!--{/if}-->
        {#if loading}
            <LinearProgress indeterminate/>
        {/if}
        <Router {routes}/>
        <!--{/if}-->
    </div>
</div>